import SectorIndustryLabel from './SectorIndustryLabel';

export default SectorIndustryLabel;
